import { createContext } from 'react';
import { FlagManager } from 'libs.flags.core';
export const FlagContext = createContext(new FlagManager({}));
